// extracted by mini-css-extract-plugin
export var breakpointXL = "1440px";
export var breakpointXXL = "2048px";
export var breakpoints = "\"@theme/breakpoints.module.css\"";
export var desktopHeader = "DesktopHeader-module--desktopHeader--b994b";